import { Users, MapPin, Car, Calendar } from 'lucide-react';
import { useStats } from '../../hooks/useStats';

const StatsSection = () => {
  const { data: stats } = useStats();

  const statsConfig = [
    { key: 'total_rides' as const, icon: Car, label: 'Happy Rides', suffix: '+' },
    { key: 'happy_clients' as const, icon: Users, label: 'Happy Clients', suffix: '+' },
    { key: 'years_experience' as const, icon: Calendar, label: 'Years Experience', suffix: '+' },
    { key: 'fleet_size' as const, icon: MapPin, label: 'Luxury Vehicles', suffix: '' },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-secondary">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats && statsConfig.map((config) => {
            const IconComponent = config.icon;
            const value = stats[config.key] || 0;
            
            return (
              <div
                key={config.key}
                className="text-center p-8 rounded-lg bg-white/5 backdrop-blur-lg hover:bg-white/10 transition-all duration-300"
              >
                <div className="inline-block p-4 rounded-full bg-primary/20 mb-4">
                  <IconComponent className="w-8 h-8 text-primary" />
                </div>
                <div className="text-4xl font-bold text-white mb-2">
                  {value}{config.suffix}
                </div>
                <div className="text-gray-300">{config.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
